<script setup lang="ts">
const route = useRoute();
const routeBaseName = useRouteBaseName();
const isBlackWeekToolbarAlertVisible = computed(() => !isSdpRoute(routeBaseName(route)));
</script>

<template>
    <div>
        <MainHeader />
        <BlackWeekToolbarAlert v-if="isBlackWeekToolbarAlertVisible" />
        <div class="flex min-h-[calc(100vh-var(--header-height))] flex-col items-center">
            <main class="flex w-full flex-1 flex-col">
                <slot />
            </main>
            <MainFooter />
        </div>
    </div>
</template>
